import AccountsCascader from '../../../../elements/Cascader/AccountsCascader'
import CentersCascader from '../../../../elements/Cascader/CentersCascader'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import { findCascadersParents, strVal } from '../../../../modules/Utils'
import React from 'react'
import { Col, Form, Input, Row } from 'antd'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'

function CargoLinesForm (props) {
  const { line, list, delivery, accounts, centers } = props
  const { getFieldDecorator } = props.form
  const Max = Math.max(...list.map((o) => o.no), 0) + 1

  const budgetKey = get(delivery, 'budget._id', '').replace('budgets/', '')
  const [BudgetLinesSelect] = useFetchSelectUrl(
    {
      name: 'budgetsLines',
      url: `budgets/${budgetKey}/lines`,
      cache: false,
      forceFetch: true,
    },
    [budgetKey],
  )

  const purchase = get(delivery, 'purchase._id', '').replace('purchases/', '')
  const [PurchaseLinesSelect] = useFetchSelectUrl(
    {
      name: 'purchaseLines',
      url: `orders/${purchase}/lines`,
      cache: false,
      forceFetch: true,
    },
    [purchase],
    isEmpty(purchase),
  )

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="No">
            {getFieldDecorator('no', {
              initialValue: get(line, 'no') || Max,
              rules: rules.select,
            })(<Input placeholder={'No'}/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Unit(s)">
            {getFieldDecorator('unit', {
              initialValue: get(line, 'unit'),
              rules: rules.select,
            })(<Input placeholder={'unit'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Name">
            {getFieldDecorator('name', {
              initialValue: get(line, 'name'),
              rules: rules.select,
            })(<Input placeholder={'name'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Purchased">
            {getFieldDecorator('purchased', {
              initialValue: get(line, 'purchased'),
              rules: rules.select,
            })(<Input placeholder={'purchased'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Delivered">
            {getFieldDecorator('delivered', {
              initialValue: get(line, 'delivered'),
              rules: rules.select,
            })(<Input placeholder={'delivered'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Requisitioned">
            {getFieldDecorator('requisitioned', {
              initialValue: get(line, 'requisitioned'),
              rules: rules.select,
            })(<Input placeholder={'requisitioned'}/>)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Budget Line">
            {getFieldDecorator('budgetLine._id', {
              initialValue: get(line, 'budgetLine._id'),
            })(<BudgetLinesSelect keyAtr={'_id'} valueAtr={'name'} placeholder={'budgetLine'}/>)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Purchase Line">
            {getFieldDecorator('purchaseLine._id', {
              initialValue: get(line, 'purchaseLine._id'),
            })(<PurchaseLinesSelect keyAtr={'_id'} valueAtr={'name'} placeholder={'Purchase Line'}/>)}
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Account">
            {getFieldDecorator('account._id', {
              initialValue: findCascadersParents(accounts, strVal(line, 'account._id')),
              rules: rules.select,
            })(<AccountsCascader placeholder={'account'}/>)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Center">
            {getFieldDecorator('center._id', {
              initialValue: findCascadersParents(centers, strVal(line, 'center._id')),
              rules: rules.select,
            })(<CentersCascader placeholder={'Select Center'}/>)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

CargoLinesForm.propTypes = {}
CargoLinesForm.defaultProps = {}

export default Form.create()(CargoLinesForm)
